import React from 'react';
import { IconProps } from '../types';

export const PRIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            d="M15.0086 28.0786L1.90363 23.2966V1.77783L15.0086 6.55979L29.6655 1.77783V9.81417"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <line
            x1="1"
            y1="-1"
            x2="7.58042"
            y2="-1"
            transform="matrix(-0.951923 -0.306339 -0.311714 0.950176 12.6589 11.3955)"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <line
            x1="1"
            y1="-1"
            x2="7.58042"
            y2="-1"
            transform="matrix(0.951923 -0.306339 0.311714 0.950176 19.0453 11.3955)"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <line
            x1="1"
            y1="-1"
            x2="7.58042"
            y2="-1"
            transform="matrix(-0.951923 -0.306339 -0.311714 0.950176 12.6589 17.3115)"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <line
            x1="1"
            y1="-1"
            x2="7.58042"
            y2="-1"
            transform="matrix(-0.951923 -0.306339 -0.311714 0.950176 12.6589 23.2275)"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M23.6438 25.5732L24.8339 27.3877C25.2359 28.0543 25.0213 28.9198 24.3547 29.3218C23.6881 29.7238 22.8226 29.5092 22.4206 28.8426L19.0585 23.4413"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M30.5327 23.9248L23.342 22.9082L19.8625 23.3377C18.4211 23.5156 17.1041 22.4551 16.9206 20.9686C16.7371 19.4822 17.7566 18.1332 19.198 17.9553L22.6776 17.5257L29.4051 14.7909L30.5327 23.9248Z"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
    </svg>
);
